import * as React from "react"
import theme from "../../theme"
import { Flex } from "rebass"
import { Member } from "BookingSystem/db/Member"
import { observer } from "mobx-react"
import styled from "styled-components"
import InputWrapper from "BookingSystem/components/InputWrapper"
import InputLabel from "BookingSystem/components/InputLabel"
import Input from "BookingSystem/components/Input"
import InputIconWrapperEnd from "BookingSystem/components/InputIconWrapperEnd"
import { BookingFlow } from "BookingSystem/BookingFlow"
import { Modal } from "BookingSystem/utils/Modal"
import { MemberFormComp } from "../Members/MemberFormComp"
import { MemberForm } from "../Members/MemberForm"

const StyledInputLabel = styled(InputLabel)`
  color: black;
  background-color: white;
`
const StyledInputWrapper = styled(InputWrapper)`
  width: 100%;
  height: 42px;
  background: ${theme.colors.white};
  margin-bottom: 4%;
  margin-top: 4%;
`

@observer
export class PayingMember extends React.Component<{
  model: Member
  flow: BookingFlow
}> {
  render() {
    const { model, flow } = this.props

    function editPayingMember() {
      const modal = new Modal(flow)
      modal.title = "Edit information."
      modal.primaryButtonText = "Done"
      modal.primaryDisabled = false
      modal.children = React.createElement(MemberFormComp, {
        model: new MemberForm(model, flow.db)
      })
      flow.showModal(() => modal)
    }

    return (
      <Flex flexDirection="column">
        <StyledInputWrapper>
          <StyledInputLabel>First Name</StyledInputLabel>
          <Input
            disabled
            type="text"
            placeholder="First Name"
            value={model ? model.object.firstName : ""}
          />
          <InputIconWrapperEnd>
            <i
              onClick={() => editPayingMember()}
              className="fas fa-pencil-alt"
            />
          </InputIconWrapperEnd>
        </StyledInputWrapper>
        <StyledInputWrapper>
          <StyledInputLabel>Last Name</StyledInputLabel>
          <Input
            disabled
            type="text"
            placeholder="Last Name"
            value={model ? model.object.lastName : ""}
          />
          <InputIconWrapperEnd>
            <i
              onClick={() => editPayingMember()}
              className="fas fa-pencil-alt"
            />
          </InputIconWrapperEnd>
        </StyledInputWrapper>
        <StyledInputWrapper>
          <StyledInputLabel>Address</StyledInputLabel>
          <Input
            disabled
            type="text"
            placeholder="Address"
            value={model ? model.addressFriendlyWithoutZip : ""}
          />
          <InputIconWrapperEnd>
            <i
              onClick={() => editPayingMember()}
              className="fas fa-pencil-alt"
            />
          </InputIconWrapperEnd>
        </StyledInputWrapper>
        <StyledInputWrapper>
          <StyledInputLabel>Zip Code</StyledInputLabel>
          <Input
            disabled
            type="text"
            placeholder="Zip Code"
            value={model ? model.object.zip : ""}
          />
          <InputIconWrapperEnd>
            <i
              onClick={() => editPayingMember()}
              className="fas fa-pencil-alt"
            />
          </InputIconWrapperEnd>
        </StyledInputWrapper>
      </Flex>
    )
  }
}
